import { type ScrollCallback } from 'lenis'
import { useLenis } from 'lenis/react'
import { useEffect } from 'react'

export function useScroll(callback: ScrollCallback, deps: any[] = []) {
	const lenis = useLenis()

	useEffect(() => {
		if (!lenis) return

		lenis.on('scroll', callback)

		return () => {
			lenis.off('scroll', callback)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lenis, callback, [...deps]])
}
